// extracted by mini-css-extract-plugin
export default {"headerContainer":"pages_headerContainer__pAxYk","mobileHeader":"pages_mobileHeader__E+WX2","header":"pages_header__wGYoS"};